import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { FsLprFilters } from './lpr-filters';

export class FsLprFiltersListResponse extends SnModel {
  @Expose()
  public filters: FsLprFilters;

  @Expose()
  public generatedAt: string;

  constructor(data = {}) {
    super();
    this.fromJSON(data);
  }
}
